"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StaffAddOnWaitingPeriodDetails = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var StaffAddOnWaitingPeriodDetails = exports.StaffAddOnWaitingPeriodDetails = function StaffAddOnWaitingPeriodDetails(_ref) {
  var plan = _ref.plan,
    addOnKey = _ref.addOnKey,
    waitingPeriods = _ref.waitingPeriods;
  var waitingPeriodDefinitions = waitingPeriods || plan.waitingPeriods.detailed.itemisedWaitingPeriods;
  if (!waitingPeriodDefinitions || !waitingPeriodDefinitions[addOnKey]) {
    return null;
  }
  var _waitingPeriodDefinit = waitingPeriodDefinitions[addOnKey],
    waitTime = _waitingPeriodDefinit.waitTime,
    label = _waitingPeriodDefinit.label;
  if (waitTime === 'No waiting period') {
    return /*#__PURE__*/_react["default"].createElement("span", {
      className: "addOnWaitingPeriodMessage"
    }, "There is no waiting period for ", label, ".");
  }
  return /*#__PURE__*/_react["default"].createElement("span", {
    className: "addOnWaitingPeriodMessage"
  }, "The waiting period for ", label, " is ", waitTime);
};
StaffAddOnWaitingPeriodDetails.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  plan: _propTypes["default"].any,
  // eslint-disable-next-line react/forbid-prop-types
  waitingPeriods: _propTypes["default"].any,
  addOnKey: _propTypes["default"].string
};